import apiClient from "../utils/apiClient";

class RazorpayService {
  constructor() {
    this.key = "rzp_live_ReCdEAUgkGUGKB";
    // this.key = "rzp_test_SpiBycCHfNLC7U";
  }

  // generateOrderId() {
  //   return "order_" + Math.random().toString(36).substring(7);
  // }

  async loadRazorpayScript() {
    if (window.Razorpay) {
      return true;
    }

    return new Promise((resolve) => {
      const script = document.createElement("script");
      script.src = "https://checkout.razorpay.com/v1/checkout.js";
      script.async = true;
      script.onload = () => resolve(true);
      script.onerror = () => {
        console.error("Failed to load Razorpay SDK");
        resolve(false);
      };
      document.body.appendChild(script);
    });
  }

  // createDummyOrder() {
  //   return {
  //     id: this.generateOrderId(),
  //     amount: 14900, // Rs. 149 in paise
  //     currency: "INR",
  //     receipt: "rcpt_" + Math.random().toString(36).substring(7),
  //   };
  // }

  verifyPayment(response) {
    // Simulate payment verification
    // In production, this would be done on the backend
    if (
      response.razorpay_payment_id &&
      response.razorpay_order_id &&
      response.razorpay_signature
    ) {
      return {
        verified: true,
        paymentId: response.razorpay_payment_id,
        orderId: response.razorpay_order_id,
        signature: response.razorpay_signature,
      };
    }
    throw new Error("Payment verification failed");
  }

  async initializePayment({ onSuccess, onError, userData }) {
    try {
      const isLoaded = await this.loadRazorpayScript();
      if (!isLoaded) {
        throw new Error("Razorpay SDK failed to load");
      }

      const response = await apiClient.post(
        "/transactions/order/test/",
        {},
        {
          params: {
            domainId: userData.domain_id,
          },
        }
      );
      const order = response.data.data;
      // console.log("Order : ", order);

      const options = {
        key: this.key,
        amount: order.amount,
        currency: order.currency,
        name: "Yapassio",
        description: "Aptitude Evaluation",
        order_id: order.order_id,
        handler: async (response) => {
          try {
            // console.log(response);
            // console.log("payment id:", response.razorpay_payment_id);
            // console.log("signature:", response.razorpay_signature);
            // console.log("order id:", response.razorpay_order_id);
            const verificationResponse = await apiClient.post(
              "/transactions/verify",
              {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                user_email: userData.email,
              }
            );
            // console.log("Verification Response : ", verificationResponse);
            // const verification = this.verifyPayment(response);

            if (verificationResponse.data.success) {
              const paymentDetails = {
                transactionId: verificationResponse.data.paymentId,
                orderId: verificationResponse.data.orderId,
                amount: order.amount / 100, // Convert paise to rupees
                timestamp: new Date().toISOString(),
                status: "success",
              };

              onSuccess && onSuccess(paymentDetails);
              console.log("Payment successful:", paymentDetails);
            }
          } catch (error) {
            console.error("Payment verification failed:", error);
            onError && onError(error);
          }
        },
        prefill: {
          name: `${userData.firstName} ${userData.lastName}`,
          email: userData.email,
          contact: userData.phone,
        },
        theme: {
          color: "#F37254",
        },
        modal: {
          animate: true,
          backdropClose: false,
          escape: false,
          handleBack: true,
          confirm_close: true,
          ondismiss: () => {
            console.log("Payment modal closed by user");
            onError && onError(new Error("Payment cancelled by user"));
          },
        },
        retry: {
          enabled: false,
        },
      };

      const razorpay = new window.Razorpay(options);

      razorpay.on("payment.failed", function (response) {
        console.error("Payment failed:", response.error);
        onError && onError(new Error(response.error.description));
      });

      razorpay.open();
    } catch (error) {
      console.error("Payment initialization failed:", error);
      onError && onError(error);
    }
  }
  async initializeWorkshopPayment({ onSuccess, onError, userData }) {
    try {
      const isLoaded = await this.loadRazorpayScript();
      if (!isLoaded) {
        throw new Error("Razorpay SDK failed to load");
      }

      const response = await apiClient.post(
        "/transactions/order/workshop/",
        {}
      );
      const order = response.data.data;
      // console.log("Order : ", order);

      const options = {
        key: this.key,
        amount: order.amount,
        currency: order.currency,
        name: "Yapassio",
        description: "100-Day Workshop",
        order_id: order.order_id,
        handler: async (response) => {
          try {
            // console.log(response);
            // console.log("payment id:", response.razorpay_payment_id);
            // console.log("signature:", response.razorpay_signature);
            // console.log("order id:", response.razorpay_order_id);
            const verificationResponse = await apiClient.post(
              "/transactions/verify",
              {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                user_email: userData.email,
              }
            );
            // console.log("Verification Response : ", verificationResponse);
            // const verification = this.verifyPayment(response);

            if (verificationResponse.data.success) {
              const paymentDetails = {
                transactionId: verificationResponse.data.paymentId,
                orderId: verificationResponse.data.orderId,
                amount: order.amount / 100, // Convert paise to rupees
                timestamp: new Date().toISOString(),
                status: "success",
              };

              onSuccess && onSuccess(paymentDetails);
              console.log("Payment successful:", paymentDetails);
            }
          } catch (error) {
            console.error("Payment verification failed:", error);
            onError && onError(error);
          }
        },
        prefill: {
          name: `${userData.name}`,
          email: userData.email,
          contact: userData.whatsappNumber,
        },
        theme: {
          color: "#F37254",
        },
        modal: {
          animate: true,
          backdropClose: false,
          escape: false,
          handleBack: true,
          confirm_close: true,
          ondismiss: () => {
            console.log("Payment modal closed by user");
            onError && onError(new Error("Payment cancelled by user"));
          },
        },
        retry: {
          enabled: false,
        },
      };

      const razorpay = new window.Razorpay(options);

      razorpay.on("payment.failed", function (response) {
        console.error("Payment failed:", response.error);
        onError && onError(new Error(response.error.description));
      });

      razorpay.open();
    } catch (error) {
      console.error("Payment initialization failed:", error);
      onError && onError(error);
    }
  }
  async initializeIIITHPayment({ onSuccess, onError, userData }) {
    try {
      const isLoaded = await this.loadRazorpayScript();
      if (!isLoaded) {
        throw new Error("Razorpay SDK failed to load");
      }

      const response = await apiClient.post("/transactions/order/iiith_prep/", {
        category_id: userData.category.id,
        price: userData.category.price,
      });
      const order = response.data.data;
      // console.log("Order : ", order);

      const options = {
        key: this.key,
        amount: order.amount,
        currency: order.currency,
        name: "Yapassio",
        description: "IIITH_prep",
        order_id: order.order_id,
        handler: async (response) => {
          try {
            // console.log(response);
            // console.log("payment id:", response.razorpay_payment_id);
            // console.log("signature:", response.razorpay_signature);
            // console.log("order id:", response.razorpay_order_id);
            const verificationResponse = await apiClient.post(
              "/transactions/verify",
              {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                user_email: userData.email,
              }
            );
            // console.log("Verification Response : ", verificationResponse);
            // const verification = this.verifyPayment(response);

            if (verificationResponse.data.success) {
              const paymentDetails = {
                transactionId: verificationResponse.data.paymentId,
                orderId: verificationResponse.data.orderId,
                amount: order.amount / 100, // Convert paise to rupees
                timestamp: new Date().toISOString(),
                status: "success",
              };

              onSuccess && onSuccess(paymentDetails);
              console.log("Payment successful:", paymentDetails);
            }
          } catch (error) {
            console.error("Payment verification failed:", error);
            onError && onError(error);
          }
        },
        prefill: {
          name: `${userData.name}`,
          email: userData.email,
          contact: userData.whatsappNumber,
        },
        theme: {
          color: "#F37254",
        },
        modal: {
          animate: true,
          backdropClose: false,
          escape: false,
          handleBack: true,
          confirm_close: true,
          ondismiss: () => {
            console.log("Payment modal closed by user");
            onError && onError(new Error("Payment cancelled by user"));
          },
        },
        retry: {
          enabled: false,
        },
      };

      const razorpay = new window.Razorpay(options);

      razorpay.on("payment.failed", function (response) {
        console.error("Payment failed:", response.error);
        onError && onError(new Error(response.error.description));
      });

      razorpay.open();
    } catch (error) {
      console.error("Payment initialization failed:", error);
      onError && onError(error);
    }
  }
  async initializeCoursePayment({ onSuccess, onError, userData }) {
    try {
      const isLoaded = await this.loadRazorpayScript();
      if (!isLoaded) {
        throw new Error("Razorpay SDK failed to load");
      }
      console.log(userData);
      const response = await apiClient.post(
        `/transactions/order/course/${userData.course_id}`,
        {}
      );
      const order = response.data.data;
      // console.log("Order : ", order);

      const options = {
        key: this.key,
        amount: order.amount,
        currency: order.currency,
        name: "Yapassio",
        description: "Course",
        order_id: order.order_id,
        handler: async (response) => {
          try {
            // console.log(response);
            // console.log("payment id:", response.razorpay_payment_id);
            // console.log("signature:", response.razorpay_signature);
            // console.log("order id:", response.razorpay_order_id);
            const verificationResponse = await apiClient.post(
              "/transactions/verify",
              {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                user_email: userData.email,
              }
            );
            // console.log("Verification Response : ", verificationResponse);
            // const verification = this.verifyPayment(response);

            if (verificationResponse.data.success) {
              const paymentDetails = {
                transactionId: verificationResponse.data.paymentId,
                orderId: verificationResponse.data.orderId,
                amount: order.amount / 100, // Convert paise to rupees
                timestamp: new Date().toISOString(),
                status: "success",
              };

              onSuccess && onSuccess(paymentDetails);
              console.log("Payment successful:", paymentDetails);
            }
          } catch (error) {
            console.error("Payment verification failed:", error);
            onError && onError(error);
          }
        },
        prefill: {
          name: `${userData.firstName} ${userData.lastName}`,
          email: userData.email,
          contact: userData.phone,
        },
        theme: {
          color: "#F37254",
        },
        modal: {
          animate: true,
          backdropClose: false,
          escape: false,
          handleBack: true,
          confirm_close: true,
          ondismiss: () => {
            console.log("Payment modal closed by user");
            onError && onError(new Error("Payment cancelled by user"));
          },
        },
        retry: {
          enabled: false,
        },
      };

      const razorpay = new window.Razorpay(options);

      razorpay.on("payment.failed", function (response) {
        console.error("Payment failed:", response.error);
        onError && onError(new Error(response.error.description));
      });

      razorpay.open();
    } catch (error) {
      console.error("Payment initialization failed:", error);
      onError && onError(error);
    }
  }
  async initializeCounsellingPayment({ onSuccess, onError, userData }) {
    try {
      const isLoaded = await this.loadRazorpayScript();
      if (!isLoaded) {
        throw new Error("Razorpay SDK failed to load");
      }
      console.log(userData);
      const response = await apiClient.post(
        `/transactions/order/counselling`,
        {}
      );
      const order = response.data.data;
      // console.log("Order : ", order);

      const options = {
        key: this.key,
        amount: order.amount,
        currency: order.currency,
        name: "Yapassio",
        description: "Counselling",
        order_id: order.order_id,
        handler: async (response) => {
          try {
            // console.log(response);
            // console.log("payment id:", response.razorpay_payment_id);
            // console.log("signature:", response.razorpay_signature);
            // console.log("order id:", response.razorpay_order_id);
            const verificationResponse = await apiClient.post(
              "/transactions/verify",
              {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                user_email: userData.email,
              }
            );
            // console.log("Verification Response : ", verificationResponse);
            // const verification = this.verifyPayment(response);

            if (verificationResponse.data.success) {
              const paymentDetails = {
                transactionId: verificationResponse.data.paymentId,
                orderId: verificationResponse.data.orderId,
                amount: order.amount / 100, // Convert paise to rupees
                timestamp: new Date().toISOString(),
                status: "success",
              };

              onSuccess && onSuccess(paymentDetails);
              console.log("Payment successful:", paymentDetails);
            }
          } catch (error) {
            console.error("Payment verification failed:", error);
            onError && onError(error);
          }
        },
        prefill: {
          // name: `${userData.firstName} ${userData.lastName}`,
          email: userData.email,
          // contact: userData.phone,
        },
        theme: {
          color: "#F37254",
        },
        modal: {
          animate: true,
          backdropClose: false,
          escape: false,
          handleBack: true,
          confirm_close: true,
          ondismiss: () => {
            console.log("Payment modal closed by user");
            onError && onError(new Error("Payment cancelled by user"));
          },
        },
        retry: {
          enabled: false,
        },
      };

      const razorpay = new window.Razorpay(options);

      razorpay.on("payment.failed", function (response) {
        console.error("Payment failed:", response.error);
        onError && onError(new Error(response.error.description));
      });

      razorpay.open();
    } catch (error) {
      console.error("Payment initialization failed:", error);
      onError && onError(error);
    }
  }
  async initializeAISubscribePayment({ onSuccess, onError, userData, plan }) {
    try {
      const isLoaded = await this.loadRazorpayScript();
      if (!isLoaded) {
        throw new Error("Razorpay SDK failed to load");
      }
      console.log(userData);
      const response = await apiClient.post(`/transactions/order/ai`, {
        plan: plan.id,
      });
      const order = response.data.data;
      // console.log("Order : ", order);

      const options = {
        key: this.key,
        amount: order.amount,
        currency: order.currency,
        name: "Yapassio",
        description: "AI Subscription",
        order_id: order.order_id,
        handler: async (response) => {
          try {
            // console.log(response);
            // console.log("payment id:", response.razorpay_payment_id);
            // console.log("signature:", response.razorpay_signature);
            // console.log("order id:", response.razorpay_order_id);
            const verificationResponse = await apiClient.post(
              "/transactions/verify",
              {
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                user_email: userData.email,
              }
            );
            // console.log("Verification Response : ", verificationResponse);
            // const verification = this.verifyPayment(response);

            if (verificationResponse.data.success) {
              const paymentDetails = {
                transactionId: verificationResponse.data.paymentId,
                orderId: verificationResponse.data.orderId,
                amount: order.amount / 100, // Convert paise to rupees
                timestamp: new Date().toISOString(),
                status: "success",
              };
              if (plan.id !== "day_pass") {
                await apiClient.post(
                  `/ai/user/${userData.mongoUserId}/ai-subscription`,
                  {
                    plan: plan.id,
                  }
                );
              } else {
                await apiClient.post(`/ai/unlimited-day-pass`, {
                  userId: userData.mongoUserId,
                });
              }
              onSuccess && onSuccess(paymentDetails);
              console.log("Payment successful:", paymentDetails);
            }
          } catch (error) {
            console.error("Payment verification failed:", error);
            onError && onError(error);
          }
        },
        prefill: {
          // name: `${userData.username}`,
          email: userData.email,
          // contact: userData.phone,
        },
        theme: {
          color: "#F37254",
        },
        modal: {
          animate: true,
          backdropClose: false,
          escape: false,
          handleBack: true,
          confirm_close: true,
          ondismiss: () => {
            console.log("Payment modal closed by user");
            onError && onError(new Error("Payment cancelled by user"));
          },
        },
        retry: {
          enabled: false,
        },
      };

      const razorpay = new window.Razorpay(options);

      razorpay.on("payment.failed", function (response) {
        console.error("Payment failed:", response.error);
        onError && onError(new Error(response.error.description));
      });

      razorpay.open();
    } catch (error) {
      console.error("Payment initialization failed:", error);
      onError && onError(error);
    }
  }
}

export default new RazorpayService();
